import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/company_settings/Page";

export const PATH = "/vendors/settings/company_settings";

function CompanySetting() {
	return (
		<>
			<NskHead title="管理会社一覧" />
			<Component />
		</>
	);
}

export default CompanySetting;
